import { types } from "../actions";

export default (state = null, { type, payload }) => {
  switch (type) {
    case types.SET_DERIVED_CUSTOMER_GROUP:
      return payload;
    case types.RESET:
      return null;
    default:
      return state;
  }
};
